<script>
import ArtistFormServices from "../../../services/artist_form.js";
import AlertError from "@/components/alert_error";

export default {
  components: { AlertError },
  data() {
    return {
      //Page errors.
      errors: [],

      result: null,
      uuid: this.$route.params.uuid,

      loading: true,
      showAlert: false,
      notFound: false,
    };
  },
  methods: {
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    verify() {
      ArtistFormServices.getByUuid(this.uuid)
        .then((response) => {
          this.result = {
            Id: response.data.data.serial_number,
            fullName: response.data.data.full_name,
            date: response.data.data.created_at,
            artists: response.data.data.artists.map((a) => {
              return {
                artwork_name: a.artwork_name,
                main_name: a.sub.main["name_" + this.$i18n.locale],
              };
            }),
          };
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status == 404) {
            this.notFound = true;
          } else {
            this.handleError(error);
          }
          this.loading = false;
        });
    },
  },
  mounted() {
    this.verify();
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <!-- Features start -->
    <section class="section con-all-page" id="features">
      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-header text-center">
              <div class="con-logo">
                <img
                  height="60px"
                  src="@/assets/images/logo3.png"
                  loading="lazy"
                  alt="logo"
                />
                <a target="_blank" href="https://qadatalnasr.com"
                  ><h4>{{ $t("pages.qr_verify.title") }}</h4></a
                >
              </div>
              <p class="sub-title">{{ $t("pages.qr_verify.sub_title") }}</p>
            </div>
          </div>

          <div v-if="loading" class="col-md-12 mt-4">
            <div class="text-center">
              <h4>{{ $t("pages.qr_verify.loading.title") }}</h4>
              <h5>{{ $t("pages.qr_verify.loading.note") }}</h5>
            </div>
          </div>
          <div v-if="!loading && notFound" class="col-md-12 mt-4">
            <div class="text-center">
              <h4>{{ $t("pages.qr_verify.no_result") }}</h4>
            </div>
          </div>
          <div
            v-if="!loading && !notFound && result != null"
            class="col-md-12 mt-2 mb-4"
            style="min-height: calc(100vh - 365px)"
          >
            <div class="qr-details">
              <div class="title-separator">
                <h4 class="font-lg">{{ $t("pages.qr_verify.card_info.title") }}</h4>
              </div>
              <div class="check-name mb-3">
                <img
                  height="27px"
                  src="@/assets/images/check.png"
                  loading="lazy"
                  alt="logo"
                />
                <h4>{{ result.fullName }}</h4>
              </div>

              <p class="mb-1">
                <span>{{ $t("pages.qr_verify.card_info.date") }} </span>
                <span>{{ result.date }}</span>
              </p>
              <p>
                <span>{{ $t("pages.qr_verify.card_info.form_number") }} </span
                ><span>{{ result.Id }}</span>
              </p>

              <h4 class="artwork-title">
                {{ $t("pages.qr_verify.card_info.artist_title") }}
              </h4>
              <ol class="centered-list mb-0">
                <li v-for="artist in result.artists" :key="artist.id">
                  <p>
                    <span>{{ artist.main_name }}</span>
                    <i class="mdi mdi-chevron-left"></i>
                    <span>{{ artist.artwork_name }}</span>
                  </p>
                </li>
              </ol>
            </div>
          </div>
          <div class="col-lg-12">
            <!-- Footer start -->
            <footer class="landing-footer">
              <div class="container">
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <img src="@/assets/images/logo.png" alt height="50" />
                    <span class="mx-2">{{ $t("pages.footer.title") }}</span>
                  </div>
                  <div class="col-md-6">
                    <p class="mt-1 text-md-end ltr-text d-sm-block mb-0">
                      {{ new Date().getFullYear() }} {{ $t("pages.footer.copy_right") }}
                    </p>
                  </div>
                </div>
              </div>
            </footer>
            <!-- Footer end -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->
  </div>
</template>
